import {
  NavigationMode,
  NavigationModeType,
  NavigationTheme,
  NavigationThemeType,
} from "./constants";
import { Application, ApplicationType } from "./constants/app";

export function sanitizeTheme(theme: NavigationThemeType): NavigationThemeType {
  if (!Object.keys(NavigationTheme).includes(theme)) {
    return NavigationTheme.light;
  }
  return theme;
}

export function sanitizeMode(mode: NavigationModeType): NavigationModeType {
  if (!Object.keys(NavigationMode).includes(mode)) {
    return NavigationMode.navbar;
  }
  return mode;
}

export function sanitizeApp(app: string): ApplicationType {
  if (!Object.keys(Application).includes(app)) {
    return Application.default;
  }
  return app as ApplicationType;
}
